<template>
  <div class="animated fadeInLeft authentication-bg">
    <div class="account-pages">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 mb-5">
            <div class="card mt-4">
              <!-- Logo -->
              <div class="card-header pt-3 pb-3 text-center bg-primary">
                <span class="text-white font-weight-bold h2">{{ companyName }}</span>
              </div>
              <div class="card-body p-4">
                <div class="text-center m-auto">
                  <img src="@/assets/images/mail_sent.svg" alt="mail sent image" height="64">
                  <h4 class="text-dark-50 text-center mt-4 font-weight-bold">Please check your email</h4>
                  <p class="text-muted mb-4">
                    An email has been sent to
                    <b>{{ email }}</b>.
                    Please check for an email from company and click on the included OTP code to
                    login to your account.
                  </p>
                </div>
                <form>
                  <div class="form-group mb-0 text-center">
                    <router-link to="/login">
                      <button class="btn btn-primary btn-lg" type="button">
                        <i class="mdi mdi-home mr-1"></i>Back to Login
                      </button>
                    </router-link>
                  </div>
                </form>
              </div>
              <!-- end card-body-->
            </div>
            <!-- end card-->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmMail",
  data() {
    return {
      email: "",
      companyName:
        JSON.parse(sessionStorage.getItem("companyName")) || "NIPIGE",
    };
  },
  mounted() {
    const verifyData = this.$store.getters["passwordReset/getInfoGatter"];
    if (verifyData && verifyData.email) {
      this.email = verifyData.email;
    } else if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
};
</script>

<style scoped>
.authentication-bg {
  background-image: url("/img/bg-pattern-light.svg");
  background-size: cover;
  background-position: center;
}
.bg-primary {
  background-color: var(--primary) !important;
}
.card-header:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 30px 5px !important;
}
.btn-primary {
  background: rgb(114, 124, 245) !important;
  border: none !important;
  border-radius: 2px !important;
  box-shadow: 0px 1px 5px 1px #989ff0 !important;
}
.form-control {
  height: calc(1.5em + 0.75rem + 10px) !important;
}
.card-body {
  margin: 56px !important;
}
.card{
  border: none !important;
  box-shadow: 0px 1px 5px 1px #cdcfea !important;
}
</style>